import { Environments } from "@ose/enums";

export const environment = {
  name: Environments.PRODUCTION,
  pageTitlePrefix: "OSE",
  baseUrl: 'https://api.onesecondexchange.com',
  oseIsDisabled: false,
  recaptcha: {
    siteKey: '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',
  },
};